import { Paper } from '@material-ui/core';
import { TableCell, TableContainer } from '@material-ui/core';
import styled from 'styled-components';

export const WrapperTabela = styled(Paper)`
  padding: 1rem;

  width: 100%;

  display: flex;
  flex-direction: column;

  position: relative;

  .MuiTableContainer-root {
    max-height: ${(props) => props.height};

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }
  }

  > nav.MuiPagination-root {
    align-self: flex-end;

    margin-top: 1.5rem;
  }
`;

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 2rem;

  > p {
    text-transform: uppercase;

    font-weight: 700;
    font-size: 1.2rem;
  }
`;

export const Loading = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.5);

  width: 100%;
  height: 100%;

  z-index: 99;
`;

export const WrapperSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  flex: 1;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 2rem;

  p {
    font-size: 1.2rem;
    font-weight: 700;

    color: #666;
  }

  span {
    text-transform: uppercase;
  }
`;


export const WrapperContainer = styled(TableContainer)`
  height: ${({ maxHeight }) => maxHeight};
  max-height: 100%;

  position: relative;

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.01) !important;
    box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 30%);
  }

  tbody.MuiTableBody-root tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.015);
  }
`


export const GroupButtonsActions = styled.div`
  position: absolute;
  right: ${({ isLeft }) => `-${isLeft}px`};

  margin-top: -0.5rem;

  display: ${({ show }) => (show === 0 ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;

  padding: 0.4rem 1.5rem;

  background: rgba(255, 255, 255, 0.9);

  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  button {
    padding: 0;

    svg {
      font-size: 2rem;
    }

    + button {
      margin-left: 1.5rem;
    }

    &:hover {
      color: #3f51b5;
    }
  }
`;



export const GroupButtons = styled.div`
  //position: absolute;
  margin-top: -0.5rem;
  
  align-items: center;
  justify-content: center;

  //padding: 0.4rem 1.5rem;

  background: rgba(255, 255, 255, 0.9);

  //border-top-left-radius: 4px;
  //border-bottom-left-radius: 4px;

  button {
    padding: 0px 0px;

    svg {
      font-size: 2rem;
    }

    /* + button {
      margin-left: 1.5rem;
    }  */

    &:hover {
      color: #3f51b5;
    }
  }
`;
